"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = exports.parentAccountHostedZoneId = exports.parentAcccountId = exports.parentHostedZoneName = void 0;
const groupDefinitions_1 = require("./Cognito/groupDefinitions");
const userInvites_1 = require("./Cognito/userInvites");
const overrides_1 = require("./Lambda/overrides");
const Ruleset_1 = require("./Ruleset");
const S3_1 = require("./S3");
const v020DefaultEnvironmentSettings_1 = require("./v020DefaultEnvironmentSettings");
const debug = process.env.REACT_APP_DEBUG === 'true' && false;
exports.parentHostedZoneName = 'iotv.link';
exports.parentAcccountId = '252855055641';
exports.parentAccountHostedZoneId = 'Z037408026LR1VED1RWZN';
const TLD = exports.parentHostedZoneName;
const mailFromSubDomain = 'mail';
const mailFromAccountName = 'support'; // info
const { projectCode, AWS_DEFAULT_REGION, REACT_APP_PROJECT_CODE, REACT_APP_DEPLOYMENT_STAGE, stage = REACT_APP_DEPLOYMENT_STAGE, REACT_APP_AWS_DEFAULT_REGION, } = process.env;
const shortProjectCode = (_a = (projectCode !== null && projectCode !== void 0 ? projectCode : REACT_APP_PROJECT_CODE)) === null || _a === void 0 ? void 0 : _a.substring(0, 4);
const getInternalAccountDomain = () => `${stage !== null && stage !== void 0 ? stage : REACT_APP_DEPLOYMENT_STAGE}.${shortProjectCode}.${TLD}`;
/** used for example in s3 CORS configuration */
const getUIUrls = () => [
//`https://app.${getInternalAccountDomain()}`,
// `https://*.${getInternalAccountDomain()}`,
];
exports.config = {
    entityReadings: 'S3_ATHENA_GLUE',
    google: {
        gcp: {
            clientId: '903446274831-lshl3denji3m3qpc3fg74r015mlapd5u.apps.googleusercontent.com',
            apiKey: 'AIzaSyCVQdK7-DIokXhFlNbpcwan0_RE4iX1Zos',
        },
    },
    ventureTypeExtensions: {
        Area: {
            subtype: ['Paddock', 'ExclusionZone', 'IrrigationArea'],
        },
    },
    weather: {
        openWeather: {
            apiKey: 'e489737747db3e59e835aeaee9cd1180',
        },
    },
    domain: stage === 'prod' ? 'watertogrow.com' : undefined,
    parentAccountDomain: undefined,
    internalAccountDomain: getInternalAccountDomain(),
    mailFromSubDomain,
    mailFromAccountName,
    uiUrls: getUIUrls(),
    apiConfigs: [
        {
            name: 'V020Api',
            endpoint: `https://control.${REACT_APP_DEPLOYMENT_STAGE}.v020.iotv.link`,
            region: (_b = AWS_DEFAULT_REGION !== null && AWS_DEFAULT_REGION !== void 0 ? AWS_DEFAULT_REGION : REACT_APP_AWS_DEFAULT_REGION) !== null && _b !== void 0 ? _b : 'never',
        },
    ],
    aws: {
        environments: {
            ...v020DefaultEnvironmentSettings_1.defaultEnvironmentSettings,
        },
        ApiGateway: {
            ConsumerAPI: { enableVpcAndIPv6: false }, // dont use redis, yet
        },
        ComputeDeploymentConfig: {
            networkData: {
                computeService: stage === 'dev' ? 'LAMBDA' : 'FARGATE',
            },
            fanOut: {
                computeService: stage === 'dev' ? 'LAMBDA' : 'FARGATE',
            },
            entityState: {
                computeService: stage === 'dev' ? 'LAMBDA' : 'FARGATE',
            },
        },
        Cognito: { groupDefinitions: groupDefinitions_1.groupDefinitions, userInvitationConfig: userInvites_1.userInvitationConfig },
        Lamdba: overrides_1.lambdaOverrides,
        S3: { UIBuckets: S3_1.uiBucketDef },
        ECS: {
            Redis: {
                // NO SCALING
                sizing: stage === 'prod' ? { cpu: 2048, memoryLimitMiB: 16384 } : stage === 'test' ? { cpu: 256, memoryLimitMiB: 512 } : { cpu: 256, memoryLimitMiB: 512 },
            },
            FanOut: {
                // NO SCALING
                sizing: stage === 'prod'
                    ? { cpu: 256, memoryLimitMiB: 1024 }
                    : stage === 'test'
                        ? { cpu: 256, memoryLimitMiB: 512 } // test ok
                        : { cpu: 256, memoryLimitMiB: 512 },
            },
            NetworkData: {
                // Min 2 tasks
                sizing: stage === 'prod'
                    ? { cpu: 256, memoryLimitMiB: 512 }
                    : stage === 'test'
                        ? { cpu: 512, memoryLimitMiB: 1024 } // test ok
                        : { cpu: 256, memoryLimitMiB: 512 },
            },
            Wideawake: {
                // NO SCALING
                sizing: stage === 'prod'
                    ? { cpu: 512, memoryLimitMiB: 1024 }
                    : stage === 'test'
                        ? { cpu: 512, memoryLimitMiB: 1024 } // test ok
                        : { cpu: 256, memoryLimitMiB: 512 },
            },
            EntityState: {
                // Min 4 tasks
                sizing: stage === 'prod' ? { cpu: 1024, memoryLimitMiB: 2048 } : stage === 'test' ? { cpu: 512, memoryLimitMiB: 2048 } : { cpu: 256, memoryLimitMiB: 512 },
            },
        },
    },
    apps: {
        webUI: {
            ventureName: 'Water To Grow',
            initialRedirect: 'HOMEPAGE',
            useSpecializedViews: true,
            supportEmail: 'support@watertogrow.com',
            pruneGenericEntities: true,
        },
    },
    iotv: {
        'device-control-arbitration': {
            allowDownlinkDuplication: true,
        },
        // "system-provisioning": {
        //     useDeprecatedCustomerHierachy: true, // for v020 this should be predicated on test | prod
        // }
    },
    BaseData: Ruleset_1.rules,
};
